import React from "react";
import SharedApplication from "../../App";
import { AppRuntimeProvider } from "../shared/AppRuntimeContext";
import { PLANY_CARE_APP } from "./appDefinition";

export default function PlanyCareApp() {
  return (
    <AppRuntimeProvider app={PLANY_CARE_APP}>
      <SharedApplication />
    </AppRuntimeProvider>
  );
}
